export default __webpack_public_path__ + "images/165e5b896ccf13fba14dd0f490944fa7.svg";